import settings from '@settings';

export const divider = {
	height: '.5px',
	width: '100%',
	

};